import Swal from "sweetalert2";
import Logo from "../assets/images/logo.png";
import "../style/registrationclosedalert.css";

// Popup dipakai saat pendaftaran ditutup sementara (1 Year Program, 1 Month Course,
// dan Scholarship) — user diarahkan ke WhatsApp untuk masuk waiting list.
const showRegistrationClosedAlert = () => {
  Swal.fire({
    imageUrl: Logo,
    imageWidth: 64,
    imageHeight: 57,
    imageAlt: "Cutting Edge Academy",
    title: "Class Is Now Fully Seated",
    html: `
      <p style="margin:0 0 6px 0;">We're so delighted by your enthusiasm!</p>
      <p style="margin:0;">Reach us on WhatsApp to join the waiting list.</p>
    `,
    background: "white",
    color: "black",
    showCloseButton: true,
    confirmButtonColor: "#1da851",
    confirmButtonText: '<i class="bi bi-whatsapp"></i> WhatsApp',
    customClass: {
      closeButton: "cea-swal-close",
      confirmButton: "cea-swal-whatsapp",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      window.open("https://wa.me/628984001333", "_blank");
    }
  });
};

export default showRegistrationClosedAlert;
